import * as React from "react";
import styled from "styled-components";

import { CompanyMembershipSection } from "../entities";
import Translate from "../../common/components/Translate";
import Icon from "../../common/components/Icon";

interface Props {
  section: CompanyMembershipSection;
  onDelete?(section: CompanyMembershipSection): void;
}

interface State {
  open: boolean;
}

class MembershipSectionEditPopup extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  public componentDidMount() {
    window.addEventListener("click", this.onClose);
  }

  public componentWillUnmount() {
    window.removeEventListener("click", this.onClose);
  }

  public onClose = () => {
    this.setState({ open: false });
  };

  public onClickEllipsis = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    const { open } = this.state;
    this.setState({ open: !open });
  };

  public onClickDelete = () => {
    const { onDelete, section } = this.props;
    onDelete!(section);
  };

  public onClickCancel = () => {
    this.onClose();
  };

  public render() {
    const { open } = this.state;
    return (
      <Base>
        <EllipsisIcon name="wt-icon-ellipsis-h" onClick={this.onClickEllipsis} open={open} />
        {open ? (
          <Menu>
            <Item onClick={this.onClickDelete}>
              <Translate id="company.members.delete_team" />
            </Item>
            <Item onClick={this.onClickCancel}>
              <Translate id="company.buttons.cancel" />
            </Item>
          </Menu>
        ) : null}
      </Base>
    );
  }
}

const Base = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
`;

const EllipsisIcon = styled(Icon)`
  font-size: 19px;
  &:hover {
    color: rgba(0, 0, 0, 0.702);
  }
  color: ${(props: { open: boolean }) => (props.open ? "rgba(0, 0, 0, 0.702)" : "rgba(0, 0, 0, 0.27)")};
`;

const Menu = styled.div`
  position: absolute;
  padding: 5px 0;
  background: white;
  width: 260px;
  border-radius: 6px;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
  transform: translateX(-50%);
  left: 50%;
`;

const Item = styled.div`
  padding: 10px 0;
  font-size: 14px;
  text-align: center;
  color: rgba(0, 0, 0, 0.27);
  &:last-child {
    border-top: 2px solid #fafafa;
  }
  &:hover {
    color: rgba(0, 0, 0, 0.702);
  }
`;

export default MembershipSectionEditPopup;



// WEBPACK FOOTER //
// ./frontend/src/company_memberships/components/MembershipSectionEditPopup.tsx